var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBase = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 118 107",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M53.665 53.667H.332V1.547C.332.875.874.333 1.546.333h50.906c.672 0 1.213.542 1.213 1.214v52.12Z",
  fill: "#8486EC"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.186 107h-5.52a1.336 1.336 0 0 1-1.334-1.333v-52h53.333v6.854C53.665 86.192 32.858 107 7.186 107Z",
  fill: "#397FC0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M64.332 52.12V1.74c0-.776.63-1.407 1.406-1.407h50.38c1.375 0 2.063 1.662 1.089 2.636l-50.24 50.245c-.974.968-2.635.281-2.635-1.094Z",
  fill: "#FF667D"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M117.665 80.333c0 14.73-11.937 26.667-26.666 26.667-14.73 0-26.667-11.938-26.667-26.667 0-14.729 11.938-26.666 26.667-26.666 14.729 0 26.666 11.937 26.666 26.666Z",
  fill: "#00BEA9"
})));
export default SvgBase;